export const LIST = 'LIST';
export const LOAD = 'LOAD';
export const DIALOG = 'DIALOG';
export const SUCCESS_STATUS = 'SUCCESS_STATUS';
export const ERROR_STATUS = 'ERROR_STATUS';
export const ERROR_MESSAGE = 'ERROR_MESSAGE';
export const SEND_RECEIPT_RESPONSE = 'SEND_RECEIPT_RESPONSE';
export const ID = 'ID';
export const LOAD_FILE = 'LOAD_FILE';
export const FILE_CONVERTED = 'FILE_CONVERTED';

// Filtros
export const FILTERS_INITIAL_DATE = 'FILTERS_INITIAL_DATE';
export const FILTERS_FINAL_DATE = 'FILTERS_FINAL_DATE';
export const FILTERS_STATUS = 'FILTERS_STATUS';
export const FILTERS_REASON = 'FILTERS_REASON';
export const FILTERS_AMOUNT = 'FILTERS_AMOUNT';
export const FILTERS_ORDINATION = 'FILTERS_ORDINATION';
export const SHOW_FILTERS = 'SHOW_FILTERS';
export const CURRENT_PAGE = 'CURRENT_PAGE';
export const LIMIT = 'LIMIT';
